'use es6';

export const isTrackAwardAddedToUpwork = (state, trackId) => state.app.trackIdsRecentlySentToUpwork.includes(trackId);